// export const AccountKey = "5794NFxsOqQobazstxYCpiwLtKjD";
// export const UserID = "KINETIK";

//export const baseURL = "https://www.claim.md/services";
export const responseURL = "https://www.claim.md/services/response";

const redirectUser = () => {
  if (localStorage.userID === "Ska7SbnM7") {
    return "https://kinetik-billing-demo.herokuapp.com/api"
  }
  else { return "https://kinetik-billing.herokuapp.com/api" }
}

// //local kinetik-billing-backend api
export const kinetik_api_url = redirectUser();

// //remote api
//  export const submitBatchURL = 'https://kinetik-billing.herokuapp.com/api/submit/batch';
//  export const kinetik_api_url= 'https://kinetik-billing.herokuapp.com/api';

// DEMO API
// export const kinetik_api_url= https://kinetik-billing-demo.herokuapp.com/







export const cvsHeader = [
  "charge",
  "date_of_service",
  "ins_number",
  "modifier",
  "pat_add",
  "pat_city",
  "pat_dob",
  "pat_name_first",
  "pat_name_last",
  "pat_sex",
  "pat_state",
  "pat_zip",
  "payer_id",
  "prodecure_code",
  "total_charge",
  "units"
];





// WEBPACK FOOTER //
// ./src/app/utilities/const.js